var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#32E2B9","fillRule":"evenodd","d":"M11.625 11.227a6.354 6.354 0 0 1-2.989.761 6.353 6.353 0 0 1-2.989-.76C2.5 11.413 0 13.776 0 16.662v1.347l.6.175c.116.032 2.887.815 8.036.815 5.15 0 7.92-.783 8.037-.815l.6-.175v-1.347c0-2.886-2.5-5.25-5.648-5.436v.001zm-2.989-.863c2.919 0 5.182-3 5.182-5.581C13.818 2.145 11.494 0 8.636 0 5.78 0 3.455 2.145 3.455 4.783c0 2.58 2.263 5.58 5.181 5.58v.001z"}));
}

User.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19"};

module.exports = User;

User.default = User;
